export const appendScript = (source) => {
    const script = document.createElement("script");
    script.src = source;
    script.async = true;
    document.body.appendChild(script);
}